import { Component, OnInit } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { ReportesCarteraService } from '../../../services/reportes/reportes-cartera.service';
import { SucursalesService } from '../../../services/sucursales.service';

@Component({
    selector: 'cartera-general',
    templateUrl: './cartera-general.component.html'
  })

export class CarteraGeneralComponent implements OnInit {
    public reportData: any [] = [];
    public totales: any = {};
    public isLoading: boolean = true;

    public sucursales: any[] = [];
    public sucursal: any = {id:null};
    public sucursalPorDefecto: string = "";

    constructor(
        private helperService: HelpersService,
        private reportesService: ReportesCarteraService,
        private sucursalesService : SucursalesService
    ){
    }

    public ngOnInit() {
        this.getSucursales();
    }

    private getSucursales(){
        this.isLoading = true;
        this.sucursalesService.get().subscribe(
          (response)=>
          {
            const jsonResult = response.json();
            if(jsonResult.content){
              this.sucursales = jsonResult.content.data;
              if (this.sucursales.length>1){
                this.sucursalPorDefecto = "Seleccione";
              } else if(this.sucursales.length>0){
                this.sucursal =  this.sucursales[0];
              }
              this.isLoading = false;
              this.updateReporte(); 
            }
            
          }, error =>
          {
            // se resuelve error 403 y 500
            this.isLoading = false;
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }
    
    sucursalChanged(sucursal){
        if(sucursal){
        this.sucursal = sucursal;
        this.updateReporte();
        }
    }

    public updateReporte(){
        this.reportesService.general({sucursal:this.sucursal.id}, false).subscribe(
            (response)=>
            {
            const jsonResult = response.json();
            let items = [];
            let totales = {};
            if(jsonResult.content ){
                if(jsonResult.content.items){
                    items = jsonResult.content.items;
                }
                if(jsonResult.content.totales){
                    totales = jsonResult.content.totales;
                }
            }

            this.reportData = items;
            this.totales = totales;
            setTimeout(() => {this.isLoading = false}, 3000);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    //Imprimir pantalla
    public print(){
        window.print();
    }

    public descargar() {

        this.reportesService.general({sucursal:this.sucursal.id}, true).subscribe(
            (response)=>
            {
                const fileUrl = window.URL.createObjectURL(response.blob());
                //Muestra el archivo en una nueva ventana
                window.open(fileUrl);
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/cartera/general/cartera-general.component.ts